export const DATA_PRIVACY = 'dataPrivacy';
export const GDPR = 'gdpr';
export const REUPLOAD = 'reupload';